import type { Product } from '@/types';

export interface ProductViewFilters {
  searchQuery?: string;
  categoryId?: number;
  subcategoryId?: number;
}

function matchesSearch(product: Product, query: string) {
  const haystack = [
    product.name,
    product.shortDescription,
    product.description,
    product.category?.name,
    product.subcategory?.name,
    String(product.price ?? ''),
    String(product.quantity ?? ''),
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  return haystack.includes(query);
}

export function filterProducts(
  products: Product[] | undefined,
  { searchQuery = '', categoryId, subcategoryId }: ProductViewFilters
): Product[] | undefined {
  if (!products) return products;

  let result = products;

  if (categoryId != null) {
    result = result.filter(
      (product) => (product.categoryId ?? product.category?.id) === categoryId
    );
  }

  if (subcategoryId != null) {
    result = result.filter(
      (product) =>
        (product.subcategoryId ?? product.subcategory?.id) === subcategoryId
    );
  }

  const query = searchQuery.trim().toLowerCase();
  if (query) {
    result = result.filter((product) => matchesSearch(product, query));
  }

  return result;
}
